import Vue from "vue";
Vue.filter("pluralize", function (number, words) {
    number = Math.abs(number) % 100;
    let numByModulo = number % 10;
    if (number > 10 && number < 20) return words[2];
    if (numByModulo > 1 && numByModulo < 5) return words[1];
    if (numByModulo === 1) return words[0];
    return words[2];
});
